export const environment = {
  production: true,
  apiBaseUrl: 'https://bookingdexter.com'
};
